"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveReferences = exports.getGatsbyImageData = exports.ImageFormat = exports.pkgName = void 0;
exports.pkgName = 'gatsby-source-sanity';
var getGatsbyImageProps_1 = require("./images/getGatsbyImageProps");
Object.defineProperty(exports, "ImageFormat", { enumerable: true, get: function () { return getGatsbyImageProps_1.ImageFormat; } });
Object.defineProperty(exports, "getGatsbyImageData", { enumerable: true, get: function () { return getGatsbyImageProps_1.getGatsbyImageData; } });
var resolveReferences_1 = require("./util/resolveReferences");
Object.defineProperty(exports, "resolveReferences", { enumerable: true, get: function () { return resolveReferences_1.resolveReferences; } });
//# sourceMappingURL=index.js.map